<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 1.tabbar-container-start -->
    <tabbar :tabbarIndex="1"></tabbar>
    <!-- 1.tabbar-container-end -->

    <!-- 2.main-container-start -->
    <div class="main">
	<div class="df-maina-ddtit"><span>订单详情</span></div>
      <div class="bottom">
		<div class="df-ordertit"><span>订单详情</span></div>
        <div class="info">
          <div class="top">订单信息</div>
          <div class="bottom">
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">订单时间:</div>
                <div class="right">
                  {{ currentPageInfo.createTime || "暂无" }}
                </div>
              </div>
              <div class="item flexStyle2">
                <div class="left">订单状态:</div>
                <div class="right right1">
                  <span>{{ order_status(currentPageInfo.status) || "" }}</span>
                </div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">订单编号:</div>
                <div class="right">
                  {{ currentPageInfo.orderNum || "暂无" }}
                </div>
                <div
                  class="copy hands"
                  @click="copyText(currentPageInfo.orderNum)"
                >
                  复制
                </div>
              </div>
              <div class="item flexStyle2">
                <div class="left">总金额:</div>
                <div class="right">¥{{ currentPageInfo.money || "0.00" }}</div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">运费:</div>
                <div class="right">
                  ¥{{ currentPageInfo.moneyYun || "0.00" }}
                </div>
              </div>
              <div class="item flexStyle2">
                <div class="left">商品金额:</div>
                <div class="right">
                  {{ currentPageInfo.moneyGoods || "0.00" }}
                </div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">支付时间:</div>
                <div class="right">{{ currentPageInfo.payTime || "暂无" }}</div>
              </div>
              <div class="item flexStyle2">
                <div class="left">支付方式:</div>
                <div class="right">
                  <span v-if="currentPageInfo.payType == 0">余额</span>
                  <span v-else-if="currentPageInfo.payType == 1">微信</span>
                  <span v-else-if="currentPageInfo.payType == 2">支付宝</span>
                  <span v-else>暂无</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="info">
          <div class="top">收货人信息</div>
          <div class="bottom">
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">收货人:</div>
                <div class="right">
                  {{ currentPageInfo.consignee || "暂无" }}
                </div>
              </div>
              <div class="item flexStyle2">
                <div class="left">联系方式:</div>
                <div class="right">
                  {{ currentPageInfo.consigneePhone || "暂无" }}
                </div>
              </div>
            </div>
            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">收货地址:</div>
                <div class="right">
                  {{ currentPageInfo.province || ""
                  }}{{ currentPageInfo.city || ""
                  }}{{ currentPageInfo.area || ""
                  }}{{ currentPageInfo.consigneeAddr || "暂无" }}
                </div>
              </div>
            </div>

            <div class="line flexStyle2">
              <div class="item flexStyle2">
                <div class="left">快递方式:</div>
                <div class="right">
                  {{ currentPageInfo.deliveryName || "暂无" }}
                </div>
              </div>
              <div class="item flexStyle2">
                <div class="left">快递单号:</div>
                <div class="right">
                  {{ currentPageInfo.deliveryNum || "暂无" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="info">
          <div class="top">商品信息</div>
          <div
            class="bottom"
            v-if="
              currentPageInfo.orderItemList != null &&
                currentPageInfo.orderItemList.length > 0
            "
          >
            <div
              class="line line2 flexStyle2"
              v-for="(item, index) of currentPageInfo.orderItemList"
              :key="index"
            >
              <div class="item item2 flexStyle2">
                <div class="left">商品名称:</div>
                <div class="right">{{ item.goodsName || "暂无" }}</div>
              </div>
              <div class="item item2 flexStyle2">
                <div class="left">商品数量:</div>
                <div class="right">{{ item.goodsCount || "暂无" }}</div>
              </div>
              <div class="item item2 flexStyle2">
                <div class="left">商品价格:</div>
                <div class="right">¥{{ item.shopPrice || "暂无" }}</div>
              </div>
            </div>
          </div>
          <div v-else>{{ currentPageInfo.goodsDetail || "暂无" }}</div>
        </div>
      </div>
      <div class="goBack">
        <el-button
          size="small"
          style="width:90px;background:#9cbbd8;color:#fff;position:relative;z-index:999;"
          @click="goBack"
        >
          返 回
        </el-button>
      </div>
    </div>
    <!-- 2.main-container-end -->

    <!-- 100.footer-container-start -->
    <c-footer></c-footer>
    <!-- 100.footer-container-end -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import footer from "../../components/footer/footer";
import { orderDetailRequest } from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      currentPageInfo: {
        // 1.1.currentPageInfo
        orderItemList: [],
      },
      token: "", // 1.2.token
    };
  },

  components: {
    // 2.components
    tabbar, // 2.1.tabbar
    cFooter: footer, // 2.2.footer
  },

  methods: {
    // 3.methods
    copyText(value) {
      // 3.1.copyText
      let inputObject = document.createElement("input");
      document.body.appendChild(inputObject);
      inputObject.style.visibility = "none";
      inputObject.value = value;
      inputObject.select();
      document.execCommand("copy");

      this.$message({
        showClose: true,
        message: "已复制到剪切板",
        type: "success",
      });
      inputObject.style.display = "none";
    },

    getCurrentPageInfo() {
      // 3.2.获取信息
      orderDetailRequest(this.orderId).then((res) => {
        if (res) {
          this.currentPageInfo = res.data;
        }
      });
    },

    goBack() {
      // 3.3.返回
      this.$router.go(-1);
    },
  },

  mounted() {
    if (this.$route.query.orderId) {
      this.orderId = this.$route.query.orderId;

      if (localStorage.token) {
        this.token = localStorage.token;
        this.getCurrentPageInfo();
      }
    }
  },
};
</script>

<style scoped lang="scss">
@import "./orderDetail.scss";
</style>
